<script setup>

const props = defineProps({
  data:{
    type: Object,
    default: null
  },
});

const emit = defineEmits(['file-added']);

async function fileAdded(event) {
  const selectedFile = event.target.files[0];


  if(selectedFile.type.includes('image')){
    await resolveThumbnail(selectedFile);
  }

  if (selectedFile) {
    emit('file-added', props.data.id, selectedFile);
  }
}

function resolveThumbnail(file){
  return new Promise(resolve => {
    let reader = new FileReader();
    reader.onloadend = ()=>{
      file.thumbnail = reader.result
      resolve();
    }
    reader.readAsDataURL(file);
  });
}

</script>

<template>
  <div
    class="max-w-lg flex relative justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
    :class="{'hidden': data.file}"
  >
    <input
      @change="fileAdded"
      :name="`newMedia[${data.id}]`"
      type="file"
      dusk="media"
      class="cursor-pointer absolute block opacity-0 w-full h-full inset-0"
    >
    <input
      v-if="data.name"
      type="hidden"
      :value="data.name"
      :name="`newMediaData[${data.id}][name]`"
    >
    <input
      v-if="typeof data.order !== 'undefined'"
      type="hidden"
      :value="data.order"
      :name="`newMediaData[${data.id}][order]`"
    >
    <input
      v-if="data.group_id"
      type="hidden"
      :value="data.group_id"
      :name="`newMediaData[${data.id}][group_id]`"
    >
    <div class="text-center">
      <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
        <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <p class="mt-1 text-sm text-gray-600">
        <button
          type="button"
          class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out"
        >
          Upload
        </button>
        or drag and drop
      </p>

      <div>
        <p class="mt-1 text-xs text-gray-500">
          Please dont use files larger than 100MB
        </p>
      </div>
    </div>
  </div>

</template>


